// extracted by mini-css-extract-plugin
module.exports = {"textBox":"header-with-subtitle-module--text-box--QLZ56","textBox__subtitle":"header-with-subtitle-module--text-box__subtitle--3QEOV"};